"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.localePath = void 0;
const UiStore_1 = __importDefault(require("../stores/UiStore"));
const localePath = (path) => path.replace(':locale', UiStore_1.default.language);
exports.localePath = localePath;
